import React from "react";
import { Bell, UserCircle } from "lucide-react";

export default function TopNav({ title }) {
  return (
    <div className="h-16 bg-white border-b shadow-sm flex items-center justify-between px-6">
      {/* Left side */}
      <h1 className="text-xl font-semibold text-gray-800">{title}</h1>

      {/* Right side */}
      <div className="flex items-center gap-4">
        <button className="relative">
          <Bell size={20} className="text-gray-600" />
          <span className="absolute -top-1 -right-1 bg-red-500 text-xs text-white rounded-full px-1">
            3
          </span>
        </button>
        <UserCircle size={28} className="text-gray-600 cursor-pointer" />
      </div>
    </div>
  );
}
